<template>
  <AdminLayout><DocsTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import DocsTable from './DocsTable.vue';

export default {
  name: 'AdminDocs',
  components: { AdminLayout, DocsTable },
};
</script>
